<template>
  <el-dialog
    :title="gift ? $t('wheel.gifts.create.edit') : $t('wheel.gifts.create.title')"
    :visible.sync="open"
    :before-close="close"
  >
    <div class="mb-4 flex items-center">
      <p class="mr-2">{{ $t('wheel.gifts.create.name') }}</p>
      <div class="flex-1">
        <input
          v-model="field.name"
          type="text"
          placeholder="Computer"
          class="w-full focus:outline-none focus:text-gray-600 p-2 border rounded"
        />
      </div>
    </div>

    <div class="mb-3 mt-3">
      <p class="font-bold mb-4">{{ $t('wheel.gifts.create.heading') }}</p>
      <div class="mt-2">
        <label v-for="lang in languages" :key="lang" class=" cursor-pointer w-full mb-2 inline-flex items-center ml-6">
          <span class="ml-2 w-1/12 inline-block">{{ lang }}</span>
          <input
            v-model="field.label[lang]"
            type="text"
            placeholder="Heading of the gift"
            class="w-11/12 mx-4 px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline"
          />
        </label>
      </div>
    </div>

    <div class="mb-3 mt-3">
      <p class="font-bold mb-4">{{ $t('wheel.gifts.create.quantity') }}</p>
      <div class="mb-2 flex items-center">
        <p class="mr-2">{{ $t('wheel.gifts.create.stock') }}</p>
        <input
          v-model="quantity"
          type="number"
          placeholder="10"
          class=" focus:outline-none focus:text-gray-600 p-2 border rounded"
        />
        <p class="ml-2">{{ $t('wheel.gifts.create.item') }}</p>
      </div>
    </div>

    <div class="flex flex-row-reverse mt-4">
      <button
        @click="save()"
        class="loader-button px-6 py-2 gap-2 rounded bg-green-500 text-blue-50 max-w-max shadow-sm hover:shadow-md"
      >
        {{ $t('wheel.actions.save') }}
        <font-awesome-icon icon="arrow-right" />
      </button>
      <button
        @click="close()"
        class="px-8 py-2 rounded border border-gray-200 text-gray-500 max-w-max shadow-sm hover:shadow-md mr-3"
      >
        {{ $t('wheel.actions.cancel') }}
      </button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LibraryManager from '../../../libraries/library-manager.vue'
import Editor from '@tinymce/tinymce-vue'
import ImportFields from '../../../common/import-fields.vue'

export default {
  name: 'FormWheelGift',

  components: { LibraryManager, Editor, ImportFields },

  props: {
    wheelId: {
      type: String,
      required: true
    },
    open: {
      type: Boolean,
      required: true
    },
    gift: {
      type: Object,
      default: null,
      required: false
    }
  },
  data() {
    return {
      position: 'top',
      target: null,
      quantity: 0,
      allreadyExisted: false,
      field: {
        name: null,
        label: {},
        stockCount: 0,
        availableCount: 0,
        usedCount: 0
      },
      targetErrorMessage: ''
    }
  },
  computed: {
    ...mapGetters('account', {
      defaultLang: 'defaultLang',
      site: 'currentSite'
    }),
    languages() {
      return this.site.languages.map(lang => lang.lang)
    }
  },
  methods: {
    ...mapActions('gifts', ['addGift', 'changeGift']),

    init() {
      if (this.gift) {
        this.allreadyExisted = true
        this.title = this.gift.name
        this.quantity = this.gift.stockCount
        this.field = this.gift
      }
    },
    checkQuantity() {
      if (this.allreadyExisted) {
        if (this.quantity >= this.field.usedCount) {
          this.field.availableCount -= this.field.stockCount - this.quantity
          this.field.stockCount = this.quantity
        } else {
          this.$notify({
            title: 'Error',
            message: "Quantity can't be lower than stock already used",
            type: 'error'
          })
          return false
        }
      } else {
        if (this.quantity >= 0) {
          this.field.availableCount = this.quantity
          this.field.stockCount = this.quantity
          this.field.usedCount = 0
        } else {
          this.$notify({
            title: 'Error',
            message: "Quantity can't be negative",
            type: 'error'
          })
          return false
        }
      }
      return true
    },
    checkLabel() {
      let allLanguages = this.site.languages.map(lang => lang.lang)

      for (let lang in allLanguages) {
        if (!this.field.label[allLanguages[lang]]) {
          this.$notify({
            title: 'Error',
            message: 'Label is required for all languages (' + allLanguages[lang] + ')',
            type: 'error'
          })
          return false
        }
      }
      return true
    },
    save() {
      if (!this.checkQuantity() || !this.field.name || !this.checkLabel()) {
        return
      }

      let gift = this.field

      if (this.allreadyExisted) {
        this.changeGift({ wheelId: this.wheelId, gift: gift })
        this.$emit('created-gift', gift)
        this.close()
      } else {
        this.addGift({ wheelId: this.wheelId, gift: gift })
        this.$emit('created-gift', gift)
        this.close()
      }
    },

    close() {
      this.$emit('close', true)
    }
  },
  mounted() {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/wheels/ui/modal/gift-create.vue